<template>
    <div class="w-full p-3 rounded-md bg-primary text-white">
      <div @click="toggle" class="flex justify-between rounded-md cursor-pointer">
        <h1 class="text-md text-gray-200">{{ title }}</h1>
        <svg xmlns="http://www.w3.org/2000/svg" :class="{'rotate-180': isOpen}" class="h-6 w-6 mr-1 transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"></path>
        </svg>
      </div>

    </div>
    <div v-if="isOpen" class="mt-4">
      <slot></slot>
    </div>
  </template>

<script setup lang="ts">

const props = defineProps({
  title: String,
  isOpenInitially: Boolean,
  class: String,
});

const isOpen = ref(props.isOpenInitially);
const toggle = () => {
  isOpen.value = !isOpen.value;
};
</script>

  <style scoped>
  .rotate-180 {
    transform: rotate(180deg);
  }
  </style>

